import { useEffect, useRef, useState } from 'react'
// redux
import { useSelector } from 'react-redux'
// hooks
import { useContentfulProgram } from 'hooks/contentful'
import useUIActions from 'hooks/useUIActions'
import useUserActions from 'hooks/useUserActions'
// contentFull
// import ProgramQuery from 'querys/content-full-queries/program-query'
// services
import AccountServices from '../../../../Auth/services/account'
import typesSlideOverlay from '../../../../../components/organisms/slide-overlay/types-slide-overlay'

/**
 * If the visitOnbordingProgram is true, it will show the overlay.
 * @returns The function showOverlay is being returned.
 */
export const useSlideOnBoarding = () => {
	const { showOverlay } = useUIActions()
	const {
		session: { visitOnbordingProgram }
	} = useSelector(state => state)

	/**
	 * ShowNotificationsOverlay() returns showOverlay() with the following parameters: open: true,
	 * template: typesSlideOverlay.programs, showIconBack: false
	 * @returns The function showOverlay is being returned.
	 */
	const showNotificationsOverlay = () => {
		return showOverlay({
			open: true,
			template: typesSlideOverlay.programs,
			showIconBack: false
		})
	}

	/* Checking if the visitOnbordingProgram is true, if it is, it will show the overlay. */
	useEffect(() => {
		if (visitOnbordingProgram) return
		showNotificationsOverlay()
	}, [visitOnbordingProgram])

	return {
		showNotificationsOverlay
	}
}

export const useControlOnboarding = () => {
	const {
		session: { userId }
	} = useSelector(state => state)

	const sliderRef = useRef()
	const { setInfoUser } = useUserActions()

	// Migrado a hook moderno
	const { loading, vistaProgramasCollection } = useContentfulProgram()
	const { onboardingUno, onboardingDos, onboardingTres, onboardingCuatro } =
		vistaProgramasCollection?.[0] || {}

	const { showOverlay } = useUIActions()

	const [currentSlide, setCurrentSlide] = useState(0)

	/**
	 * If the current slide is 3, then update the onboarding with the email, otherwise, show the overlay
	 * with the open, template, and showIconBack.
	 * @returns The function showOverlay is being returned.
	 */
	const onClickClose = () => {
		if (currentSlide === 3) {
			AccountServices.updateOnboarding({ userId }).then(res => {
				if (res.status !== 200) return
				setInfoUser({ visitOnbordingProgram: true })
			})
		}

		return showOverlay({
			open: false,
			template: null,
			showIconBack: false
		})
	}

	/**
	 * The handleCurrentSlide function takes a value as an argument and sets the current slide to that
	 * value.
	 */
	const handleCurrentSlide = value => {
		setCurrentSlide(value)
	}

	const gotoNext = () => {
		if (currentSlide === 3) return onClickClose()
		sliderRef.current.slickNext()
	}

	return {
		onboardingUno,
		onboardingDos,
		onboardingTres,
		onboardingCuatro,
		loading,
		sliderRef,
		gotoNext,
		onClickClose,
		handleCurrentSlide
	}
}
